import { useEffect, useState } from 'react'
import { LuArrowUp } from 'react-icons/lu'
import { cn } from '@/lib/cn'

/** Round button that returns to the top of long pages. */
export const BackToTop = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 1000)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <button
      type="button"
      aria-label="Back to top"
      inert={!visible}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={cn(
        'fixed bottom-5 right-4 z-30 flex h-12 w-12 items-center justify-center rounded-full border border-green-800 bg-green-700 text-white shadow-elevated transition-all duration-300 hover:bg-green-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-700 focus-visible:ring-offset-2 md:bottom-6 md:right-6',
        visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0',
      )}
    >
      <LuArrowUp aria-hidden="true" className="h-5 w-5" />
    </button>
  )
}
